import PropTypes from "prop-types";
import { useRef } from "react";
import { Button, Card, Form, Image } from "react-bootstrap";

const PDFInputFile = ({ button, onFileChange }) => {
  const fileInputRef = useRef(null);

  const handleFileChange = async (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const arrayBuffer = reader.result;
        const blob = new Blob([arrayBuffer], { type: "application/pdf" });
        blob.name = file.name;
        blob.importDate = new Date().toISOString();
        blob.numPages = file.numPages;
        onFileChange({ file, blob });
      };
      reader.readAsArrayBuffer(file);
    }
  };

  return (
    <>
      <Button
        variant={button?.color}
        disabled={button?.disabled}
        className={button?.className}
        onClick={() => fileInputRef.current.click()}
        style={button?.style}
      >
        {button?.icon && (
          <Image
            className={button?.icon?.className}
            src={button?.icon?.src}
            alt={button?.icon?.alt}
          />
        )}
        {button?.name || ""}
      </Button>

      <Form.Control
        ref={fileInputRef}
        type="file"
        className="d-none"
        accept=".pdf"
        onChange={({ target }) => {
          handleFileChange(target.files[0]);
          target.value = null;
        }}
      />
    </>
  );
};

const PDFPreviewFile = ({ pdfFile }) => {
  return (
    <Card className="border-0">
      <iframe
        src={pdfFile?.size && URL.createObjectURL(pdfFile)}
        width="100%"
        height="960px"
        title="PDF Preview"
      />
    </Card>
  );
};

PDFInputFile.propTypes = {
  button: PropTypes.object,
  onFileChange: PropTypes.func
};

PDFPreviewFile.propTypes = {
  pdfFile: PropTypes.object
};

export { PDFInputFile, PDFPreviewFile };
